import {Pane} from 'tweakpane';


const pane = new Pane();
export default pane;